<script setup>
import InputError from "@/Components/InputError.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";
import InputField from "@/Components/InputField.vue";
import InputLabel from "@/Components/InputLabel.vue";

import { defineProps, ref, watch } from "vue";
import Swal from "sweetalert2";
import { router, useForm, usePage } from "@inertiajs/vue3";

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  jenis: {
    type: Object,
    required: true,
  },
});

const form = useForm({
  id: null,
  nama_dok: "",
  jenis_dok: "",
  status: "",
  deskripsi: "",
  files: [],
});

function handleFileChange(e) {
  form.files = Array.from(e.target.files);
}
const fileInput = ref(null);

const submit = () => {
  // Kirim dengan Inertia agar form.progress tersedia untuk progress bar
  form.post(route("documents.store"), {
    forceFormData: true,
    preserveScroll: true,
    onSuccess: (page) => {
      const msg = page?.props?.flash?.success || "Dokumen berhasil disimpan.";
      Swal.fire({
        title: "Berhasil!",
        text: msg,
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        // Refresh index bila perlu atau biarkan backend melakukan redirect
        // router.visit(route("documents.index"), { preserveScroll: true, preserveState: true });
        window.location.reload();
        form.reset();
        form.files = [];
        if (fileInput.value) {
          fileInput.value.value = ""; // Reset elemen input file di DOM
        }
      });
    },
    onError: (errors) => {
      const msg =
        errors?.message || "Terjadi kesalahan saat menyimpan dokumen.";
      Swal.fire({
        title: "Gagal!",
        text: msg,
        icon: "error",
        confirmButtonText: "OK",
      });
    },
    // onProgress otomatis akan mengisi form.progress oleh Inertia
  });
};
</script>
<template>
  <div
    class="items-center justify-center p-4 bg-opacity-50 rounded-lg shadow-md border-bg-gray-200"
  >
    <form class="space-y-4" @submit.prevent="submit">
      <div>
        <InputField
          label="Nama Dokumen"
          icon="pen"
          v-model.trim="form.nama_dok"
        />
        <InputError :message="form.errors.nama_dok" class="mt-2" />
      </div>

      <!-- Deskripsi -->
      <div>
        <label for="Deskripsi" class="block text-sm font-medium text-gray-700"
          >Deskripsi</label
        >
        <textarea
          class="w-full p-2 mt-1 text-sm border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
          placeholder="Deskripsi"
          rows="4"
          v-model="form.deskripsi"
        ></textarea>
        <InputError :message="form.errors.deskripsi" class="mt-2" />
      </div>

      <!-- Jenis Dokumen -->
      <div>
        <label
          for="JenisDokumen"
          class="block text-sm font-medium text-gray-700"
          >Jenis Dokumen</label
        >
        <select
          v-model="form.jenis_dok"
          class="block w-full px-3 py-2 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
        >
          <option value="">Pilih Jenis Dokumen</option>
          <option
            v-for="item in props.jenis.data"
            :key="item.id"
            :value="item.id"
          >
            {{ item.nama }}
          </option>
        </select>
        <InputError :message="form.errors.jenis_dok" class="mt-2" />
      </div>
      <!-- Kategori -->
      <div>
        <label for="Kategori" class="block text-sm font-medium text-gray-700"
          >Kategori</label
        >
        <select
          v-model="form.status"
          class="block w-full px-3 py-2 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
        >
          <option value="">Pilih Kategori</option>
          <option value="0">Eksternal</option>
          <option value="1">Internal</option>
        </select>
        <InputError :message="form.errors.status" class="mt-2" />
      </div>

      <!-- File Upload -->
      <div>
        <InputLabel
          for="gambar"
          value="File"
          class="block text-sm font-medium text-gray-700"
        />
        <input
          type="file"
          ref="fileInput"
          multiple
          @change="handleFileChange"
          class="block w-full mt-1 text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer focus:ring-indigo-500 focus:border-indigo-500"
        />
        <progress
          v-if="form.progress"
          :value="form.progress.percentage"
          max="100"
          class="w-full mt-2"
        >
          {{ form.progress.percentage }}%
        </progress>
        <InputError :message="form.errors.file_path" class="mt-2" />
      </div>

      <!-- Submit Button -->
      <div class="mt-6">
        <PrimaryBtn type="submit" class="w-full"> Simpan Dokumen </PrimaryBtn>
      </div>
    </form>
  </div>
</template>
